/* eslint-disable camelcase */
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import {Box, useTheme, Loader} from '@spothero/ui';
import APIUtils from '@spothero/utils/api';

import Config from './Config';
import {fetchData, getTrackingLink} from './utils/data-utils';

import TitleArea from './components/TitleArea/TitleArea';
import EventList from './components/EventList/EventList';
import WidgetFooter from './components/WidgetFooter/WidgetFooter';

import '../common/reset.scss';
import '../common/common.scss';

import {
    eventWidgetStyleProps,
    pulseLoaderContainerStyleProps,
} from './EventWidgetStyleProps';
import {DEFAULT_EVENTS_PAGE_SIZE} from '../common/api/events';

APIUtils.init({
    baseUrl: 'https://spothero.com/v1/',
});

const EventWidget = ({affiliateData}) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [destinationName, setDestinationName] = useState('');
    const [destinationId, setDestinationId] = useState(Config.destinationId);
    const {
        affiliateCode,
        subAffiliateCode,
        trackingLink,
        page_size: pageSize,
        open_new_tab_on_click: openNewTabOnClickParam,
    } = affiliateData;
    const interpolatedTrackingLink =
        getTrackingLink(trackingLink) || Config.trackingLink;

    useEffect(() => {
        fetchData({
            affiliateCode,
            subAffiliateCode,
            pageSize: pageSize || DEFAULT_EVENTS_PAGE_SIZE,
        }).then(data => {
            setDestinationName(data.destinationName);
            setDestinationId(data.destinationId);
            setEvents(data.events);
            setLoading(false);
        });
    }, [affiliateCode, subAffiliateCode, pageSize]);

    const {
        partnerWidgetStyles: {
            widgetContainerStyles: customWidgetContainerStyles,
        },
    } = useTheme();

    const openNewTabOnClick = Boolean(
        openNewTabOnClickParam?.toLowerCase?.() === 'true'
    );

    return (
        <Box
            {...eventWidgetStyleProps}
            {...customWidgetContainerStyles.eventWidget}
        >
            <TitleArea destinationName={destinationName} />
            {loading ? (
                <Box
                    {...pulseLoaderContainerStyleProps}
                    {...customWidgetContainerStyles.pulseLoaderContainer}
                    data-testid="PulseLoaderContainer"
                >
                    <Loader />
                </Box>
            ) : (
                <EventList
                    events={events}
                    trackingLink={interpolatedTrackingLink}
                    destinationName={destinationName}
                    destinationId={destinationId}
                    openNewTabOnClick={openNewTabOnClick || false}
                />
            )}
            <WidgetFooter
                destinationId={destinationId}
                trackingLink={interpolatedTrackingLink}
            />
        </Box>
    );
};

EventWidget.propTypes = {
    affiliateData: PropTypes.shape({
        affiliateCode: PropTypes.number,
        subAffiliateCode: PropTypes.string,
        trackingLink: PropTypes.string,
        variant: PropTypes.string,
        page_size: PropTypes.number,
        open_new_tab_on_click: PropTypes.bool,
    }),
};

export default EventWidget;
